'use strict';
import angular from 'angular';
import ngMaterial from 'angular-material';
import bannerPopupController from './bannerPopup.component';
import bannerPopupService from './bannerpopup.service';
export default angular.module('directives.bannerpopup', [ngMaterial])
    .controller('bannerController', bannerPopupController)
    .component('bannerpopup', {
    template: require('./bannerPopup.html'),
    controller: bannerPopupController
})
    .service('bannerPopupService', bannerPopupService)
    .name;
//# sourceMappingURL=index.js.map